'use client'

import * as React from 'react'

/**
 * A tool home starts one session and then leaves for the session page, so a second
 * submit only ever duplicates it. The mutation is not pending while the entitlement
 * check awaits, and it is already settled while the browser leaves for the session
 * page, so the latch has to span both windows instead of tracking the mutation.
 */
export function useSingleSubmit(mutation: { isPending: boolean; isSuccess: boolean }) {
  const [isStarting, setIsStarting] = React.useState(false)
  const isStartingRef = React.useRef(false)
  const isSubmitting = isStarting || mutation.isPending || mutation.isSuccess

  function submit(task: () => Promise<void>) {
    if (isStartingRef.current || mutation.isPending || mutation.isSuccess) {
      return
    }
    isStartingRef.current = true
    setIsStarting(true)
    void task().finally(() => {
      isStartingRef.current = false
      setIsStarting(false)
    })
  }

  return { isSubmitting, submit }
}
